<template>
  <div style="width: 100%; height: 100%; display: flex; justify-content: center; align-items: center;">
    <div class="container mt-4">
      <div class="p-3 mb-3 bg-secondary text-white rounded shadow-sm">
  <h4 class="m-0">My Payment Details</h4>
</div>

      
  
      <!-- Loading Spinner -->
      <div v-if="loading" class="d-flex justify-content-center my-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
  
      <!-- Payments Table -->
      <!-- Payments Table -->
<div class="table-responsive d-flex justify-content-center" v-if="!loading && payments.length">
  <table class="table table-bordered table-striped mt-3 w-auto">

    <thead>
      <tr>
        <th>Institute</th>
        <th>Teacher</th>
        <th>Subject</th>
        <th>Last Payment Date</th>
        <th>Payment Status</th>
        <th>Total Paid Amount</th>
        <th>Payment History</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="payment in payments" :key="payment.id">
        <td data-label="Institute">{{ payment.institute?.institute_name }}</td>
        <td data-label="Teacher">{{ payment.teacher?.user?.first_name || 'N/A' }}</td>
        <td data-label="Subject">{{ payment.subject?.name }}</td>
        <td data-label="Last Payment Date">{{ payment.last_payment_date }}</td>
        <td data-label="Payment Status">{{ payment.payment_status }}</td>
        <td data-label="Total Paid Amount">{{ formatCurrency(payment.total_paid_amount) }}</td>
        <td>
          <button
            type="button"
            class="btn btn-sm btn-info"
            data-bs-toggle="modal"
            data-bs-target="#historyModal"
            @click="openHistoryModal(payment)"
          >
            View History
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>

  
      <!-- No payments message -->
      <p v-if="!loading && !payments.length">No payments found.</p>
  
      <!-- Modal for Payment History -->
      <div class="modal fade" id="historyModal" tabindex="-1" aria-labelledby="historyModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="historyModalLabel">Payment History</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
  <!-- Loading Spinner -->
  <div v-if="historyLoading" class="d-flex justify-content-center my-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- History List -->
  <ul v-else-if="selectedHistory?.length" class="list-group">
    <li
      v-for="history in selectedHistory"
      :key="history.id"
      class="list-group-item d-flex justify-content-between align-items-center"
    >
      <div>
        <strong>{{ history.payment_date }}</strong><br />
        <small class="text-muted">Method: {{ history.payment_method || 'N/A' }}</small>
      </div>
      <span class="badge bg-success rounded-pill">{{ formatCurrency(history.paid_amount) }}</span>
    </li>
  </ul>

  <!-- No History Message -->
  <p v-else class="text-center text-muted">No history available.</p>
</div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
  </template>
  
  
  <script>
  import axios from 'axios';
  
  export default {
  data() {
    return {
      payments: [],
      loading: false,
      selectedHistory: null,
      selectedPaymentId: null, // <- new property
      historyLoading: false, // <-- New
    };
  },
  methods: {
    fetchPayments() {
      this.loading = true;
      const teacherId = localStorage.getItem('teacher_id');

      axios.get('/get-teacher-payment-From-institute', {
        headers: {
          teacher_id: teacherId
        }
      })
      .then(response => {
        this.payments = response.data;
      })
      .catch(error => {
        console.error('Error fetching payments:', error);
      })
      .finally(() => {
        this.loading = false;
      });
    },

    openHistoryModal(payment) {
  this.selectedHistory = []; // Clear old history
  this.selectedPaymentId = payment.id;
  this.fetchPaymentHistory(payment.id);
},



    fetchPaymentHistory(paymentId) {
  this.historyLoading = true;
  axios.get('/get-teacher-payment-history', {
    headers: {
      teach_institute_payment_id: paymentId
    }
  })
  .then(response => {
    this.selectedHistory = response.data.history || [];
  })
  .catch(error => {
    console.error('Error fetching payment history:', error);
    this.selectedHistory = [];
  })
  .finally(() => {
    this.historyLoading = false;
  });
},


    formatCurrency(amount) {
      if (!amount && amount !== 0) return 'N/A';
      return new Intl.NumberFormat('en-LK', {
        style: 'currency',
        currency: 'LKR'
      }).format(amount);
    },
    // openHistoryModal(payment) {
    //   this.selectedHistory = payment.payment_histories || [];
    // }
  },
  mounted() {
    this.fetchPayments();
  }
};

  </script>
  
  <style lang="scss" scoped>
  /* Style adjustments */

  .table-responsive {
  display: flex;
  justify-content: center;
}


  .table {
    font-size: 1rem;
    margin-bottom: 1.5rem;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    display: block;
    width: auto; /* Fit content */
  }
  
  .table td,
  .table th {
    vertical-align: middle;
  }
  
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: #f9f9f9;
  }
  
  .table-hover tbody tr:hover {
    background-color: #f1f1f1;
  }
  
  .table-dark {
    background-color: #343a40;
    color: white;
  }
  
  .table th {
    font-weight: bold;
  }
  
  .text-center {
    font-size: 1.2rem;
    color: #5a5a5a;
  }
  
  .text-success {
    color: #28a745;
  }
  
  .text-warning {
    color: #ffc107;
  }
  
  p.text-center {
    font-size: 1rem;
    color: #888;
  }
  
  ul {
    list-style-type: none;
    padding-left: 0;
  }
  
  ul li {
    font-size: 0.9rem;
    color: #6c757d;
  }
  
  ul li span {
    font-style: italic;
  }


  .modal-body {
  background-color: #fdfdfd;
  padding: 1.5rem;
}

.list-group-item {
  font-size: 0.95rem;
  border: none;
  border-bottom: 1px solid #eee;
}

.list-group-item:last-child {
  border-bottom: none;
}

  
@media (max-width: 768px) {

  .table {
    width: 100%; /* allow full width on mobile */
  }

  .w-auto {
    width: 100% !important;
  }
  table thead {
    display: none;
  }
  table, tbody, tr, td {
    display: block;
    width: 100%;
  }
  tr {
    margin-bottom: 1rem;
    border-bottom: 1px solid #ccc;
  }
  td {
    text-align: right;
    padding-left: 50%;
    position: relative;
  }
  td::before {
    content: attr(data-label);
    position: absolute;
    left: 0;
    width: 45%;
    font-weight: bold;
    text-align: left;
    color: rgb(68, 68, 68);
    padding: 5px;
  }
}



  </style>
  